<template>
  <div class="legalSubdivision">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Name</label>
          <el-input type="text"
                 name="name"
                 placeholder="Name"
                 ref="name"
                 :disabled="!canEdit"
                 clearable
                 v-validate="modelValidations.name"
                 v-model="edit.name" />
          <small class="text-danger" v-show="errors.has('name')">
            {{ getError('name') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row" style="margin-top: 15px" v-if="canEdit">
      <div class="col-md-12">
        <button type="button" :disabled="isSubmitDisabled" @click="validateAndSubmit" class="btn btn-fill btn-info btn-wd pull-right">Save</button>
        <div class="form-group form-group-active-label">
          <label class="active-label">Active</label>
          <p-switch v-model="edit.active" type="primary" on-text="YES" off-text="NO"></p-switch>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {notifySuccess, notifyError} from 'src/utilities/utils'
  import Constants from 'src/utilities/constants'
  import Permissions from 'src/utilities/permissions'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import {sync} from 'vuex-pathify'
  import {OK} from 'http-status-codes'

  export default {
    props: ['data'],
    components: {
      PSwitch
    },
    computed: {
      canEdit() {
        return this.$can('edit', Permissions.LEGAL_SUBDIVISIONS)
      },
      isSubmitDisabled() {
        return this.isProcessing
      },
      edit: sync('legalSubdivisions@edit')
    },
    data () {
      return {
        legalSubdivisionSaved: false,
        constants: Constants,
        name: null,
        active: true,
        isProcessing: false,
        modelValidations: {
          name: {
            required: true,
            max: 64
          }
        }
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      async validateAndSubmit() {
        this.isProcessing = true

        if (await this.$validator.validateAll()) {
          const response = await this.$store.dispatch('save', this.$store.get('legalSubdivisions/savePayload', 'legal-subdivisions'))

          if (response.result === Constants.RETURN_CODES.SUCCESS) {
            this.$store.commit('legalSubdivisions/reset')
            this.$eventHub.$emit('legalSubdivisionSaved', response.data)
            this.legalSubdivisionSaved = true
            this.$emit('close')
            notifySuccess(this, 'Legal Subdivision Saved Successfully')
          } else if (response.result === Constants.RETURN_CODES.ERROR) {
            notifyError(this, 'Error Saving Legal Subdivision', response.errors)
          }
        }
        this.isProcessing = false
      }
    },
    async beforeMount() {
      if (!this.data) {
        // Creating new Legal Subdivision
        this.$store.commit('legalSubdivisions/resetEdit')
      } else if (this.data.name) {
        // Adding new Legal Subdivision on-the-fly
        this.$store.commit('legalSubdivisions/hydrateEdit', this.data)
      } else if (this.data.id) {
        // Editing Legal Subdivision
        this.$store.commit('legalSubdivisions/resetEdit')
        const response = await this.$store.dispatch('fetchById', {
          endpoint: Constants.ENTITY_ENDPOINTS.LEGAL_SUBDIVISIONS,
          id: this.data.id
        })

        if (OK !== response.status) {
          notifyError(this, 'Failed to load legal subdivision')
          return
        }

        this.$store.commit('legalSubdivisions/hydrateEdit', response.data)
      }
    },
    mounted () {
      this.$refs.name.focus()
    },
    destroyed() {
      if (!this.legalSubdivisionSaved) {
        this.$eventHub.$emit('noLegalSubdivisionSaved')
      }
    }
  }
</script>

<style scoped>
  .legalSubdivision {
    overflow-x: hidden;
    overflow-y: auto;
    max-height: calc(100vh - 150px);
  }
  label {
    display: block;
  }
  .table-legalSubdivision-data tr {
    border-bottom: 1px solid #d3dce6;
  }
  .table-legalSubdivision-data tr td:first-child {
    padding: 3px 12px;
  }
</style>
